import store from '@/state/store'
import { Helper } from '@/mixin/helper'
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

let customFeature = {}

function hasRemoveValidationBackDateMgm() {
  const data = getFeatureFlagValue('customFeature.mgm')
  customFeature.mgm = data
  return Array.isArray(data?.company_id) && data.company_id.includes(Helper.methods.getCompanyId())
}

function getExpectedPickupValidation() {
  return hasRemoveValidationBackDateMgm() ? 'bail|optional' : 'bail|optional|timeGteNow'
}

// Archieved for Refinement
// import IMask from 'imask'
import * as Address from '@/services/rest-api/lib/delivery/address'

// const maskOptions = {
//   mask: '00 H\\ari 0 J\\am 0 Menit',
//   blocks: {
//     '00': {
//       mask: IMask.MaskedRange,
//       from: 0,
//       to: 31,
//     },
//     0: {
//       mask: IMask.MaskedRange,
//       from: 0,
//       to: 23,
//     },
//   },
// }

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const getWeekdaysMin = (locale) =>
  locale === 'en'
    ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    : ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min']

const getAddressTableFields = (t) => [
  {
    label: translate(t, 'master.form.address.name', 'Nama Lokasi'),
    key: 'name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.category', 'Kategori Alamat'),
    key: 'category',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.fullAddress', 'Alamat Lengkap'),
    key: 'full_name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.province', 'Provinsi'),
    key: 'province',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.city', 'Kota'),
    key: 'city',
    isSortable: true,
    isRedirectable: true,
  },
]

const getDateLang = (locale) => ({
  formatLocale: {
    weekdaysMin: getWeekdaysMin(locale),
  },
})

const getDraftFields = (t, locale) => [
  {
    name: 'origin_address_id',
    showKey: 'origin_address',
    type: 'value-help',
    label: translate(t, 'delivery.fields.originAddress', 'Alamat Asal'),
    placeholder: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    validation: 'required',
    trackBy: 'id',
    getInitialObject: (obj) => obj?.origin_address_id,
    displayedBy: 'name',
    listGetter: Address.get(),
    tableFields: getAddressTableFields(t),
    gridColSpan: 2,
  },
  {
    key: 'expected_pickup_on',
    name: 'expected_pickup_on',
    label: translate(t, 'delivery.fields.estimatedPicked', 'Target Diambil'),
    placeholder: translate(t, 'global.action.selectDate', 'Pilih Tanggal'),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    validation: getExpectedPickupValidation(),
    validationMessages: {
      timeGteNow: translate(
        t,
        'delivery.validation.estimatedPickedAfterToday',
        'Target Diambil tidak boleh kurang dari hari Ini'
      ),
    },
    format: 'DD MMM YYYY HH:mm',
    showSecond: false,
    confirm: true,
    confirmText: translate(t, 'global.action.apply', 'Terapkan'),
    lang: getDateLang(locale),
  },
]

const getConfirmedFields = (t, locale) => [
  {
    name: 'origin_address_id',
    showKey: 'origin_address',
    type: 'value-help',
    label: translate(t, 'delivery.fields.originAddress', 'Alamat Asal'),
    placeholder: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    getInitialObject: (obj) => obj?.origin_address_id,
    displayedBy: 'name',
    disabled: true,
    tableFields: getAddressTableFields(t),
    listGetter: Address.get(),
    gridColSpan: 2,
  },
  {
    key: 'expected_pickup_on',
    name: 'expected_pickup_on',
    label: translate(t, 'delivery.fields.estimatedPicked', 'Target Diambil'),
    placeholder: translate(t, 'global.action.selectDate', 'Pilih Tanggal'),
    type: 'date-picker',
    validation: getExpectedPickupValidation(),
    validationMessages: {
      timeGteNow: translate(
        t,
        'delivery.validation.estimatedPickedAfterToday',
        'Target Diambil tidak boleh kurang dari hari Ini'
      ),
    },
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY HH:mm',
    showSecond: false,
    confirm: true,
    confirmText: translate(t, 'global.action.apply', 'Terapkan'),
    lang: getDateLang(locale),
  },
]

const getScheduledFields = (t, locale) => [
  {
    name: 'origin_address_id',
    showKey: 'origin_address',
    type: 'value-help',
    label: translate(t, 'delivery.fields.originAddress', 'Alamat Asal'),
    placeholder: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    getInitialObject: (obj) => obj?.origin_address_id,
    displayedBy: 'name',
    disabled: true,
    gridColSpan: 2,
  },
  {
    key: 'expected_pickup_on',
    name: 'expected_pickup_on',
    label: translate(t, 'delivery.fields.estimatedPicked', 'Target Diambil'),
    placeholder: translate(
      t,
      'delivery.placeholder.estimatedPickedUndefined',
      'Tanggal tidak ditentukan'
    ),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY HH:mm',
    lang: getDateLang(locale),
    disabled: true,
  },
]

const getOriginAddressFields = (t, locale) => ({
  Draf: getDraftFields(t, locale),
  Dikonfirmasi: getConfirmedFields(t, locale),
  'Menunggu Vendor': getConfirmedFields(t, locale),
  Ditolak: getConfirmedFields(t, locale),
  'Diterima Vendor': getConfirmedFields(t, locale),
  Dijadwalkan: getScheduledFields(t, locale),
  'Dijadwalkan Ulang': getConfirmedFields(t, locale),
  Dijalankan: getScheduledFields(t, locale),
  Diambil: getScheduledFields(t, locale),
  Terkirim: getScheduledFields(t, locale),
  Dibatalkan: getScheduledFields(t, locale),
  'Sedang Transit': getScheduledFields(t, locale),

  default: getDraftFields(t, locale),
})

export default getOriginAddressFields
